<template>
	<div id="app">
		<div class="preprod" v-if="isPreprod">You are currently using the pre-production version.</div>
		<transition name="fade" mode="out-in">
			<router-view class="app-view" />
		</transition>
	</div>
</template>

<script>

export default {
	name: 'App',

	computed: {
		isPreprod () {
			return window.location.origin === 'https://dashboard.pos.shiseido.not.live'
		}
	}
}
</script>

<style lang="scss">
@import "./assets/styles/app";

:root {
	--color-white: #fff;
	--color-black: #000;

	--color-primary: #c80421;
	--color-info: #2db7f5;
	--color-success: #19be6b;
	--color-warning: #ff9900;
	--color-error: #f75e4f;
	--color-link: #2d8cf0;

	--color-border-base: #dddee1;

	--color-title: var(--color-black);
	--color-text: var(--color-black);

	--font-stack-common: 'Arial', sans-serif;
	--font-stack-title: 'Shiseido Neue', sans-serif;

	--transition: .2s ease-in-out;
}

.preprod {
	background: var(--color-primary);
	color: var(--color-white);
	text-align: center;
	padding: 5px;
}

.preprod + .app-view {
	height: calc(100% - 28px)
}
</style>



// WEBPACK FOOTER //
// src/App.vue